namespace $.$$ {
	$mol_style_define( $shm_hitalama_skills_editor, {
		flex: { grow: 0, shrink: 0, basis: '45rem' },
		width: '45rem', maxWidth: '100%',
		Head: { flexWrap: 'nowrap' },
		Title: { minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
		Source: { minWidth: 0, maxWidth: '100%' },
		Description: { minWidth: 0, Content: { minWidth: 0 } },
		Instruction: { minWidth: 0, Content: { minWidth: 0 } },
		Description_input: { minWidth: 0, width: '100%', maxWidth: '100%', gridTemplateColumns: 'minmax(0, 1fr)' },
		Instruction_input: { minWidth: 0, width: '100%', maxWidth: '100%', gridTemplateColumns: 'minmax(0, 1fr)' },
		Description_text: { Paragraph: { padding: { left: 0, right: 0 } } },
		Instruction_text: {
			Paragraph: { padding: { left: 0, right: 0 } },
			Header: { Link: { padding: { left: 0, right: 0 } } },
		},
		// Markdown blocks already supply the same text padding as label content.
		// Keep one padding layer in view mode instead of adding both together.
		'[editing]': {
			false: {
				Description: { Content: { padding: 0 } },
				Instruction: { Content: { padding: 0 } },
			},
		},
	})
}
